export function gmcDatepickerConfig( momentPickerProvider ) {
  momentPickerProvider.options({
    format: 'DD.MM.YYYY'
  });
}

gmcDatepickerConfig.$inject = [ 'momentPickerProvider' ];



// WEBPACK FOOTER //
// ./app/shared/components/gmc-date-picker/gmc-date-picker.config.ts